(function(PaymentForm) {
    'use strict';

    // This function is meant to ensure that payment cannot be completed
    // if the registration will fail anyways due to the user not being found.
    //
    // To do this, it fills the relevant field with the e-mail that was used to sign in,
    // or hides the payment form if that field cannot be found,
    // since this field must be filled in correctly for the event registration to work.
    PaymentForm.autoFill = function() {
        // The label MUST be equal to this variable for the event registration to work.
        var requiredLabel = 'E-mailadres';
        var formWrapper = $('.js-inschrijf-formulier-wrapper');
        var username = formWrapper.data('username');
        var usernameLabel = formWrapper.find('label:contains("' + requiredLabel + '")');
        var usernameWrapper;
        var usernameInput;

        if (usernameLabel.html() !== requiredLabel) {
            formWrapper.html(
                '<p>Het betalingsformulier is niet goed geconfigureerd.' +
                ' De inschrijving kan niet worden voltooid. Probeer het later opnieuw.</p>'
            );

            return;
        }

        usernameWrapper = usernameLabel.parent('li');
        usernameInput = usernameWrapper.find('input');

        usernameInput.val(username);
        usernameWrapper.hide();
    };
})(window.Way2web.PaymentForm = window.Way2web.PaymentForm || {});
